"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var useSummaryContext_1 = require("../../react/useSummaryContext");
var ContentLine_1 = require("../contentLine/ContentLine");
var Price_1 = require("../prices/price/Price");
var carOptionStyles_1 = require("./carOptionStyles");
var PriceDisplayType_1 = require("../../../../../common/enum/PriceDisplayType");
var CarOptions = function (_a) {
    var mappedOptions = _a.mappedOptions, optionsTotal = _a.optionsTotal, displayCurrency = _a.displayCurrency;
    var style = carOptionStyles_1.default();
    var primaryOptions = useSummaryContext_1.default().priceDisplay.primaryOptions;
    var hideAccessoriesTitle = core_1.useTheme().checkoutLite.summary.hideAccessoriesTitle;
    return (<core_1.Grid item={true} className={style.optionsWrapper} data-test="summary:car_details:options_container">
      {!hideAccessoriesTitle && (<core_1.Typography variant="subtitle1" className={style.optionsSectionTitle}>
          <Translation_1.default id={'carDetails.label.optionalExtras'}/>
        </core_1.Typography>)}
      {<>
          {mappedOptions(style)}
          <core_1.Box className={style.optionsPrice}>
            <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" component="span" className={style.optionsPriceLabel}>
                  <Translation_1.default id={'label.total'}/>
                </core_1.Typography>} secondaryContent={<Price_1.default price={optionsTotal} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY_OPTIONS} className={style.optionsPriceValue} currency={displayCurrency} decimals={primaryOptions.decimalScale}/>}/>
          </core_1.Box>
        </>}
    </core_1.Grid>);
};
exports.default = CarOptions;
